import React from 'react';
import { motion } from 'framer-motion';
import { TestimonialCard } from './TestimonialCard';
export function TopTestimonialsSection() {
  const testimonials = [{
    headlineNode: <>
          After{' '}
          <span className="block text-2xl md:text-3xl font-black text-teal-600 italic mt-1" data-id="element-347">
            MULTIPLE medical specialists failed
          </span>{' '}
          to identify what was actually wrong with him and left him to suffer as
          he got worse, he finally got a Transformation Program with us. He
          thanked us for{' '}
          <span className="block text-2xl md:text-3xl font-black text-teal-600 italic mt-1" data-id="element-348">
            giving him his life back.
          </span>
        </>,
    text: `Ali... Brenden… I can't stress enough how working with this team is guaranteed to provide transformations… They're doing something revolutionary here. You'll be getting something extremely personalized, you'll be getting the care that you need, you'll be getting the support you need, the multi-faceted support you need, should you decide to work with the Peptide Science Institute, both on the emotional front, mental front, and on the medical front. Working with them is just a fantastic experience and I highly recommend this to anybody who's even considering, if you're looking for something life-changing, if you want to attack diseases that the mainstream says is not really something treatable... it will blow your mind. That's what I can guarantee.`,
    name: 'Sean L., Transformation Services Client',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kFsThom7rrs3SjPcRaZ1a1/SeanL.jpg'
  }, {
    headlineNode: <>
          From someone who personally hired many of the most well-known (and
          expensive) experts in the entire health & wellness industry. She
          accomplished{' '}
          <span className="block text-2xl md:text-3xl font-black text-teal-600 italic mt-1" data-id="element-349">
            more in 2 weeks with us than in a whole YEAR with the others.
          </span>
        </>,
    text: `Brenden all these so called proficient drs in our space and we've accomplished more in 2 weeks than in the past year... I'm honored excited and so grateful I finally found who I have been looking for.`,
    name: 'Shawna C., Peptide Mastery Buyer & Transformation Services Client',
    profileImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wu3WrEb7TMcpemyocLBB2S/Screenshot_2025-11-10_202634.png'
  }];
  return <div className="grain-section w-full px-6 py-32 bg-white" data-id="element-350">
      <div className="max-w-3xl mx-auto space-y-16" data-id="element-351">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: i * 0.1
      }} data-id="element-352">
            <TestimonialCard headlineNode={t.headlineNode} text={t.text} profileImage={t.profileImage} name={t.name} data-id="element-353" />
          </motion.div>)}

        {/* Expert Photos Side by Side */}
        <div className="bg-page-bg rounded-[3rem] p-12 border border-black/5" data-id="element-354">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-355">
            <div className="text-center space-y-4" data-id="element-356">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/r3ytD56TFByCqkHoB8LFzP/DrAli1.png" alt="Dr. Ali Mazloum" className="w-48 h-48 rounded-full object-cover mx-auto border-4 border-white shadow-md" data-id="element-357" />
              <div data-id="element-358">
                <h3 className="text-2xl font-bold text-ink" data-id="element-359">Dr. Ali Mazloum</h3>
                <p className="text-teal-600 font-semibold uppercase tracking-wider text-sm" data-id="element-360">
                  The Human MRI
                </p>
              </div>
            </div>
            <div className="text-center space-y-4" data-id="element-361">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vptGHfonavjt96KY7KsnCE/Image_2.jpg" alt="Brenden Henry" className="w-48 h-48 rounded-full object-cover mx-auto border-4 border-white shadow-md" data-id="element-362" />
              <div data-id="element-363">
                <h3 className="text-2xl font-bold text-ink" data-id="element-364">Brenden Henry</h3>
                <p className="text-teal-600 font-semibold uppercase tracking-wider text-sm" data-id="element-365">
                  World's #1 Peptide Authority
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Wilfred testimonial */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-366">
          <TestimonialCard text="I 100% would put my name behind Ali & Brenden… In terms of level of positive impact on my life, they are likely in the top 5 most important people I've ever met as they have added many years to my life and to those of my loved ones." profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/jdxYRgYb1UEVWzFMDVbhMC/WilfredA.jpg" name="Wilfred A., Peptide Mastery Owner & Transformation Services Client" data-id="element-367" />
        </motion.div>
      </div>
    </div>;
}